export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  inputWithMargin: {
    width: "49%",
    marginRight: 10,
    [theme.breakpoints.between(750, 1000)]: {
      width: "48%",
    },
    [theme.breakpoints.down(750)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "49%",
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  tableFormWidth: {
    width: 150,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    backgroundColor: "#004f70 !important",
    borderRadius: 20,
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#004f70 !important",
      color: "#000",
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  imageProgressStyle: {
    display: "flex",
    flexDirection: "row",
  },
  termStyle: {
    display: "flex",
    alignItems: "center",
  },
  imageStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    padding: 10,
  },
});
